import Text, { TEXT_VARIANT } from '@pixum/text';
import type { CSSProperties } from 'react';
import { LogoLink } from './LogoLink';
import type { SoftwareLinkListProps } from './types';
import { IconMedia } from '../../../icons';
import Label from '@pixum/label';

export function SoftwareLinkList(props: SoftwareLinkListProps) {
  const { align, direction, flow, links, title, type, constants } = props;
  const customProperties = {
    '--footer-links-list-item-align': align,
    '--footer-links-list-item-direction': direction,
    '--footer-links-list-item-flow': flow
  } as CSSProperties;

  return (
    <section className="footer__links-list-section variant-software" id={type}>
      <Text className="footer__links-list-heading" variant={TEXT_VARIANT.HEADLINE}>
        {title}
      </Text>
      <ul className="footer__links-list" style={customProperties}>
        <li className="footer__links-list-item">
          <IconMedia alt="laptop-icon" icon="laptop-dark" loading="lazy" />
        </li>
        {links.map((link, index) => (
          <li className="footer__links-list-item" key={`footer-logo-link-${type}-${index}`}>
            <LogoLink addHref={true} {...link} />
          </li>
        ))}
        <li className="footer__links-list-item">
          <Label
            icon={<IconMedia alt={constants.i18n_free} icon="check-dark" loading="lazy" />}
            text={constants.i18n_free}
          />
          <Label
            icon={<IconMedia alt={constants.i18n_virus_checked} icon="check-dark" loading="lazy" />}
            text={constants.i18n_virus_checked}
          />
        </li>
      </ul>
    </section>
  );
}
